import {Component, signal} from "@angular/core";
import {UserService} from "../../services/user.service";
import {NavigationService} from "../../shared/data-access/navigation.service";
import {NavItem, navItems} from "./components/nav-item";
import {Userrole} from "../../shared/interfaces/user";
import {environment} from "../../../environments/environment";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent {
  isExpanded = signal<boolean>(false);
  navItems: NavItem[] = navItems;

  constructor(
    protected userService: UserService,
    protected navigationService: NavigationService
  ) {
  }

  toggleSidebar() {
    this.isExpanded.set(!this.isExpanded());
  }

  get visibleNavItems(): NavItem[] {
    return this.navItems.filter((item) =>
      item.visibleToRoles.includes(this.userService.userrole() as Userrole)
    );
  }

  isCurrentUrl(activePaths: string[]): boolean {
    return activePaths.some((path) => this.navigationService.currentUrl().includes(path))
  }

  protected readonly environment = environment;
}
